@if (initialized && dto) {
    <div class="grid">
        <!-- Navigation -->
        <div class="col-12">
            <object-component-navigation-side
                    [name]="dto?.name || 'Project'"
                    [navigationItems]="navigationItems"
                    [(activeNavigationItem)]="activeNavigationItem"
                    (activeNavigationItemChange)="onNavigationItemChange($event)"
            ></object-component-navigation-side>
        </div>

        <!-- Tab Content -->
        <div class="col-12">
            @switch (activeNavigationItem?.action) {
                @case ('overview') {
                    <ea-project-overview-tab
                            [objectIdentifier]="objectIdentifier"
                            [dto]="projectDto"
                    ></ea-project-overview-tab>
                }
                @case ('sourceFiles') {
                    <ea-project-source-files-tab
                            [objectIdentifier]="objectIdentifier"
                    ></ea-project-source-files-tab>
                }
                @case ('analysisResults') {
                    <ea-project-analysis-tab
                            [objectIdentifier]="objectIdentifier"
                    ></ea-project-analysis-tab>
                }
                @case ('modelDrafts') {
                    <ea-project-model-drafts-tab
                            [objectIdentifier]="objectIdentifier"
                    ></ea-project-model-drafts-tab>
                }
                @case ('importConfigs') {
                    <ea-project-import-configs-tab
                            [objectIdentifier]="objectIdentifier"
                    ></ea-project-import-configs-tab>
                }
            }
        </div>
    </div>
}
